import { render, staticRenderFns } from "./modal_add_to_news_trend.vue?vue&type=template&id=d53a5a9a"
import script from "./modal_add_to_news_trend.vue?vue&type=script&lang=js"
export * from "./modal_add_to_news_trend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports